import React from 'react';
import styled from 'styled-components';
import FitToScreenToggle from 'PreviewComponents/SideBar/FitToScreenToggle/FitToScreenToggle';
import SizeSelector from 'PreviewComponents/SideBar/SizeSelector/SizeSelector';
import VariantSelector from 'PreviewComponents/SideBar/VariantSelector/VariantSelector';
import ArtboardSelector from 'PreviewComponents/SideBar/ArtboardSelector/ArtboardSelector';

const PanelContents = styled.div`
  position: relative;
`;

const ResponsivePanel = () => (
  <PanelContents>
    <ArtboardSelector />
    <VariantSelector />
    <SizeSelector />
    <FitToScreenToggle />
  </PanelContents>
);

export default ResponsivePanel;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/SideBar/Panels/Containers/ResponsivePanel.jsx